import { MAC_ADDRESS_REGEX } from '../../../common/utils/validationUtils.js';

const MAC_ADDRESS_SEPARATORS = /[:-]/g;
const ALL_ZERO_MAC_ADDRESS = /^0+$/;

/** A customer-owned device's MAC address must be well formed and cannot be the all-zero placeholder address. */
export const isValidMacAddress = (macAddress: string): boolean => {
  const trimmed = macAddress.trim();
  return MAC_ADDRESS_REGEX.test(trimmed) && !ALL_ZERO_MAC_ADDRESS.test(trimmed.replace(MAC_ADDRESS_SEPARATORS, ''));
};

/** The checkout API only accepts the uppercase, colon-separated form, e.g. AA:BB:CC:DD:EE:FF. */
export const normalizeMacAddress = (macAddress: string): string =>
  macAddress
    .trim()
    .replace(MAC_ADDRESS_SEPARATORS, '')
    .toUpperCase()
    .replace(/(.{2})(?=.)/g, '$1:');
